<template>
    <div>
      <Loader :active="loading" mensaje="Enviando solicitud de asistencia" />
      <v-card class="mt-4">
            <v-card-text class="text-center">
                <!-- Entrada -->
                <h4 v-if="operacion === 'Entrada'">
                  Es necesario que capture una foto con su uniforme para poder marcar asistencia.
                </h4>
                <!-- Salida -->
                <p v-if="operacion === 'Salida'">
                  Presiona el botón para marcar salida.
                  <br>
                  <strong>
                    Es importante que su salida sea marcada una vez que usted este entregando su turno a su siguiente compañero.
                  </strong>
                </p>
                <!-- completo -->
                <template v-if="operacion === 'completo'">
                  <v-icon large class="mb-2" color="success">
                    mdi-check-circle
                  </v-icon>
                  <p>
                    <strong class="text-uppercase">Su entrada y salida se han registrado exitosamente.</strong>
                    <br>
                    <br>
                    <small>
                      Las opciones volveran a mostrarse hasta su siguiente turno.
                    </small>
                  </p>
                </template>
              <!-- Tomar foto -->
              <v-btn v-if="operacion !== 'completo'" @click="tomarFoto" block :disabled="!this.esFormValido" :dark="this.esFormValido" color="black" class="mt-3">
                <v-icon left>
                    mdi-camera
                </v-icon>
                Capturar foto
              </v-btn>

              <div v-if="fotoUsuario !== null">
                <!-- Marcar asistencia -->
                <v-btn v-if="operacion === 'Entrada'" @click="marcarEntrada" block dark color="green accent-3" class="mt-3">
                  <v-icon left>
                    mdi-hand
                  </v-icon>
                  Entrada
                </v-btn>

                <!-- Marcar Salida -->
                <v-btn v-else @click="marcarSalida" block dark color="green accent-3" class="mt-3">
                  <v-icon left>
                    mdi-logout
                  </v-icon>
                  Salida
                </v-btn>
                <img class="mt-5" width="100%" :src="fotoUsuario" alt="Foto del usuario">
              </div>

              <input ref="camara" type="file" accept="image/*" capture="camera" style="display:none;" />
            </v-card-text>
        </v-card>
        <v-dialog v-model="dialog.active">
          <v-card>
            <v-card-title>
              {{ dialog.title }}
            </v-card-title>
            <v-card-text>
              {{ dialog.text }}
            </v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="dialog.active = false"
            >
              Entendido
            </v-btn>
          </v-card-actions>
          </v-card>
        </v-dialog>
    </div>
</template>
<script>
// Services
import { asistencias } from '../services/asistencias'
import { polygon } from '../services/polygon'
import { session } from '../services/session'
import { noProgramados } from '../services/no_programados'
// Components
import Loader from '../components/Loader'
import moment from 'moment'
import { gps } from '../services/gps'
export default {
  props: {
    operacion: String,
    idAsistencia: String,
    noProgramada: Boolean,
    dataNoProgramada: Object,
    idNoProgramado: String
  },
  components: {
    Loader
  },
  data () {
    return {
      fotoUsuario: null,
      fotoAsistencia: null,
      userData: {
        poligono: [],
        idUsuario: ''
      },
      dialog: {
        active: false,
        title: '',
        text: ''
      },
      loading: false
    }
  },
  methods: {
    async marcarEntrada () {
      try {
        let coords = []

        console.log('no programada', this.noProgramada)

        if (!this.noProgramada) {
          const value = await this.verificarPosicion()
          console.log('dentro de la zona', value)
          if (!value) return
        } else {
          coords = await this.getCoords()

          if (!coords) return
        }

        this.loading = true

        const { nombre_imagen: imagen, timestamp } = await this.cargarImagen()

        if (!this.noProgramada) {
          const { data } = await asistencias.entrada(this.userData.idUsuario, this.getFecha(), imagen, timestamp)

          if (data.error) throw Error(data.message)
        } else {
          const { motivo, teammate } = this.dataNoProgramada
          const { data } = await noProgramados.entrada(this.userData.idUsuario, this.getFecha(), imagen, timestamp, coords, motivo, teammate)

          if (data.error) throw Error(data.message)
        }

        this.showModalMessage('Registro exitoso', 'Su entrada ha sido registrada exitosamente')
        this.limpiarValores()

        this.$emit('entrada', true)
      } catch (err) {
        this.showModalMessage('Falló registro - Entrada', err.message)
      } finally {
        this.loading = false
      }
    },
    async marcarSalida () {
      try {
        if (!this.noProgramada) {
          const value = await this.verificarPosicion()

          console.log(value)

          if (!value) return
        }

        this.loading = true

        const { nombre_imagen: imagen } = await this.cargarImagen()

        if (!this.noProgramada) {
          const { data } = await asistencias.salida(this.userData.idUsuario, imagen, this.idAsistencia)

          if (data.error) throw Error(data.message)
        } else {
          const { data } = await noProgramados.salida(this.userData.idUsuario, imagen, this.idNoProgramado)
          if (data.error) throw Error(data.message)
        }

        this.showModalMessage('Registro exitoso', 'Su salida ha sido registrada exitosamente')
        this.limpiarValores()

        this.$emit('entrada', true)
      } catch (err) {
        this.showModalMessage('Falló regitro - Salida', err.message)
      } finally {
        this.loading = false
      }
    },
    getFecha () {
      moment().format('d-m-Y')
    },
    async cargarImagen () {
      try {
        const { data } = await asistencias.cargarImagen(this.fotoAsistencia, this.userData.idUsuario, this.getZonaHoraria(), this.operacion)
        if (data.error) throw Error('Error al momento de registrar la foto de asistencia')
        return data
        //
      } catch (err) {
        this.showErrorMessage(err)
      }
    },
    async verificarPosicion () {
      const value = await polygon.verifyCoords(this.userData.poligono)

      if (!value) {
        this.showErrorMessage('No se encuentra dentro del área de trabajo')
        return false
      }

      return true
    },
    getZonaHoraria () {
      return parseInt(new Date().toString().match(/([-][0-9]+)\s/)[1].substring(0, 3))
    },
    async getCoords () {
      try {
        const { latitude, longitude } = await gps.getCoords()
        console.log({ latitude, longitude })

        return JSON.stringify({
          lat: latitude,
          lng: longitude
        })
      } catch (err) {
        console.log(err)
        this.showErrorMessage('Error al momento de consultar la ubicación. Por favor brinde permisos al navegador para solicitar su ubicación')
        return null
      }
    },
    tomarFoto () {
      this.$refs.camara.click()
    },
    async mostrarFoto (foto) {
      this.fotoAsistencia = foto
      this.fotoUsuario = URL.createObjectURL(foto)
    },
    toBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    initCamara () {
      const camara = this.$refs.camara

      camara.addEventListener('change', e => {
        this.mostrarFoto(e.target.files[0])
      })
    },
    getData () {
      const userData = session.getData()
      this.userData = { ...userData }
    },
    showModalMessage (title, text) {
      this.dialog = {
        title,
        text,
        active: true
      }
    },
    showErrorMessage (message) {
      this.$toasted.show(message, {
        position: 'bottom-center',
        type: 'error',
        theme: 'bubble',
        icon: 'close-circle',
        duration: 5000
      })
    },
    limpiarValores () {
      this.fotoUsuario = null
      this.fotoAsistencia = null
    }
  },
  computed: {
    esFormValido () {
      if (!this.noProgramada) return true

      else if (this.noProgramada && this.operacion === 'Salida') return true

      return (this.noProgramada && this.dataNoProgramada !== null)
    }
  },
  mounted () {
    this.initCamara()
    this.getData()
  }
}
</script>
